import CryptoJS from 'crypto-js'

const ENC_PREFIX = 'ENC:'
/** Export for backward-compat decrypt of legacy values (no ENC_ prefix). */
export const getStorageSecret = (): string =>
  (typeof process !== 'undefined' && process.env?.REACT_APP_STORAGE_SECRET) || 'cliniter dental'
const getSecret = getStorageSecret

/**
 * Encrypt string for localStorage (AES).
 * Stored value is ENC_PREFIX + ciphertext for backward-compatible detection.
 */
export function encryptStorage(value: string): string {
  if (value == null || value === '') return value
  const secret = getSecret()
  const encrypted = CryptoJS.AES.encrypt(value, secret).toString()
  return ENC_PREFIX + encrypted
}

/**
 * Decrypt value from localStorage.
 * If value starts with ENC_PREFIX, decrypt and return; otherwise return as-is (backward compat).
 */
export function decryptStorage(value: string | null): string | null {
  if (value == null || value === '') return value
  if (!value.startsWith(ENC_PREFIX)) return value
  const secret = getSecret()
  const cipher = value.slice(ENC_PREFIX.length)
  const bytes = CryptoJS.AES.decrypt(cipher, secret)
  const decrypted = bytes.toString(CryptoJS.enc.Utf8)
  return decrypted || null
}

/**
 * Read from localStorage and decrypt if stored with encryptStorage.
 */
export function getSecureItem(key: string): string | null {
  try {
    const raw = localStorage.getItem(key)
    return decryptStorage(raw)
  } catch {
    return null
  }
}

/**
 * Encrypt and write to localStorage.
 */
export function setSecureItem(key: string, value: string): void {
  try {
    const toStore = value == null || value === '' ? '' : encryptStorage(value)
    localStorage.setItem(key, toStore)
  } catch (e) {
    console.warn('storage setSecureItem failed', key, e)
  }
}

/**
 * Remove item from localStorage.
 */
export function removeSecureItem(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // no-op
  }
}
